export default "__VITE_ASSET__DiIxswrK__"